import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
// import * as Sentry from '@sentry/react';
import * as CONFIG from './configs/api'
// import { Integrations } from '@sentry/tracing';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import configureStore from './store/configureStore';

const store = configureStore();

// Sentry.init({
//   dsn: CONFIG.SENTRY_DSN,
//   integrations: [
//     new Integrations.BrowserTracing(),
//   ],
//   tracesSampleRate: 0.01,
// });

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
